import React, { useEffect, useState } from 'react';
import { checkElement } from '@/components/SubSectionComponents/CleanFunctions.jsx';
import img from '@/assets/img/AncrageImgs/firstMeterAndHalf/SH+RH+RH.svg';
import S from '@/styles/reactImgsBallast.module.css';
import InfoT from '@/pages/formwork/boxes/ConfiguratorStabilizier/ImageComponents/InfoT.jsx';
import InfoD from '@/pages/formwork/boxes/ConfiguratorStabilizier/ImageComponents/InfoD.jsx';
import ConfigStabilizeInfoButton from '@/pages/formwork/boxes/ConfiguratorStabilizier/ConfigStabilizeInfoButton.jsx';

function SHRhRh({ allHeightsPanel, T, D }) {
  const [find, setFind] = useState(false);

  useEffect(() => {
    if (
      allHeightsPanel.length === 3 &&
      checkElement.firstMeterAndHalf([allHeightsPanel[0]]) &&
      checkElement.lastHalf([allHeightsPanel[1]]) &&
      checkElement.lastHalf([allHeightsPanel[2]])
    ) {
      setFind(true);
    } else setFind(false);
  }, [allHeightsPanel]);

  if (!find) {
    return null;
  }

  return (
    <div className={S.container} style={{ marginTop: -50 }}>
      <img className={S.containerImg} src={img} alt={'3m'} style={{ top: -261 }} />
      <InfoT top={140} left={145} T={T} />
      <InfoD top={257} left={109} D={D} />
      <ConfigStabilizeInfoButton top={-331} />
    </div>
  );
}

export default SHRhRh;
